module.exports = __webpack_public_path__ + "static/img/setting.bb981275.png";